import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DetailOrderComponent from "../../../components/Customer/orders/DetailOrderComponent";

const DetailOrderPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/');
    }

    return <DetailOrderComponent orderId={ params.orderId } shouldRedirect={ () => redirect() } />;
}

export default DetailOrderPage;